import React from 'react'
import '../home.css';
import SEO from '../SEO.js';


const EverydaySounds = () => {

    const secondaryFontStyle = { fontFamily: "'Raleway', sans-serif" };

    return (
        <div>
                <SEO
                    title="Everyday Sounds"
                    description="Everyday Sounds is a web-based beatmaker that turns everyday soundscapes into new music, built and redesigned by Lord Crawford."
                    path="/everydaysounds"
                />
                <div className="text-[4vw] ml-[3.5%] mt-[2%] space-y-[-2vw] invisible title-spacer" aria-hidden="true"><div>Lord</div><div>Crawford</div></div>
                <div className='pb-[6vw] px-[3.5%]'>
                    <div className='mt-[12%] md:mt-[6%] max-w-[860px]'>
                        <div className='flex flex-col md:flex-row md:items-center md:justify-between gap-6 md:gap-14'>
                            <h2
                                id="es_title"
                                className="text-[5.5vw] md:text-[2.6vw] text-cyan-400 font-normal leading-[1.05] font-limelight"
                            >
                                EVERYDAY SOUNDS
                            </h2>
                            <a
                                href="https://www.everydaysounds.live"
                                className="w-fit bg-cyan-400 px-5 py-3 text-white hover:bg-cyan-500 text-center font-raleway whitespace-nowrap md:ml-6"
                            >
                                Visit Live Project &rarr;
                            </a>
                        </div>

                        <p className="mt-10 text-[16px] md:text-[17px] leading-relaxed text-stone-700 font-raleway">
                            This web-based beatmaker was initially developed as a class project in 2022. Everyday you go outside, you naturally create your own soundscape or 'world of sounds'; whether that's from birds chirping on your walk or Adele playing from the cars outside. I thought it'd be interesting if we could capture those sounds and make new music out of it ~ Everyday Sounds. Originally built as a class project in 2022, I revived it in early 2024 with a full redesign in React and new functionality aimed at making music production accessible to anyone.
                        </p>

                        <img className="mt-8 w-[95%] md:w-[80%] mx-auto h-auto object-cover border border-black" src={require('../photos/everydaysounds/esv2_final.png')} alt="first hi-fi wireframe"/>

                        <div className="mt-10 border-t border-stone-200" />

                        <div className="mt-10">
                            <h2 className="text-[22px] md:text-[26px] font-normal text-black">Specifications</h2>
                            <div style={secondaryFontStyle} className="mt-3 text-[16px] md:text-[17px] leading-relaxed text-stone-700 font-raleway">
                                <p><b>Dates:</b> April 2022 - June 2024</p>
                                <p><b>Tools Used:</b> Javascript (React), HTML, CSS, Figma, Adobe Illustrator, Vercel</p>
                                <p><b>Role:</b> Sole Developer and Designer</p>
                                <p className="mt-2">
                                    <b>URL/Link:</b>{' '}
                                    <a href="https://www.everydaysounds.live" style={secondaryFontStyle} className="text-cyan-500 font-semibold hover:underline font-raleway">
                                        everydaysounds.live
                                    </a>
                                </p>
                            </div>
                        </div>

                        <div className="mt-10 border-t border-stone-200" />

                        <div className="mt-10">
                            <h2 className="text-[22px] md:text-[26px] font-normal text-black">Research</h2>
                            <p className='mt-3 text-[16px] md:text-[17px] leading-relaxed text-stone-700 font-raleway'>
                                In order to understand the landscape of DAWs (Digital Audio Workstation), I first invested hours creating music in Audacity which is a more rudimentary tool compared to Logic or Ableton. It was here where I first learned how to apply audio tracks and create looped beats.
                            </p>
                            <img className="mt-8 w-[90%] md:w-[60%] mx-auto h-auto object-cover" src={require('../photos/everydaysounds/audacity_cs.png')} alt="lo-fi wireframe"/>
                            <p className='mt-8 text-[16px] md:text-[17px] leading-relaxed text-stone-700 font-raleway'>
                                Following Audacity, I learned how to use Ableton and Logic, which is where I was introduced to more robust beat sequencers that could add thousands of sound effects. Subsequently, I purchased an AKAI MPK Mini (a small physical drum pad that you can plug into your computer). These tools showed me a more advanced user experience around beat-making with a sequencer, and ultimately, I aimed to create something easier for people to use.
                            </p>
                        </div>

                        <div className="mt-10 border-t border-stone-200" />

                        <div className="mt-10">
                            <h2 className="text-[22px] md:text-[26px] font-normal text-black">Everyday Sounds (V1) — Design Process</h2>

                            <h3 className="mt-6 text-[18px] md:text-[20px] font-medium text-black font-raleway">Wireframes</h3>
                            <div className="mt-4 flex flex-col md:flex-row place-content-center gap-4">
                                <div className="w-[95%] md:w-[45%] mx-auto md:mx-0">
                                    <p className="text-center text-[15px] text-stone-500 font-raleway">low fidelity wireframe</p>
                                    <img className="mt-3 w-full h-[220px] md:h-[280px] object-contain" src={require('../photos/everydaysounds/home.jpg')} alt="first hi-fi wireframe"/>
                                </div>
                                <div className="w-[95%] md:w-[45%] mx-auto md:mx-0">
                                    <p className="text-center text-[15px] text-stone-500 font-raleway">mid fidelity wireframe</p>
                                    <img className="mt-3 w-full h-[220px] md:h-[280px] object-contain" src={require('../photos/everydaysounds/v1es.png')} alt="first hi-fi wireframe"/>
                                </div>
                            </div>

                            <h3 className="mt-10 text-[18px] md:text-[20px] font-medium text-black font-raleway">Demo (May 2022)</h3>
                            <video className='mt-4 w-[95%] md:w-[80%] mx-auto' controls poster={require('../photos/everydaysounds/v1es.png')}>
                                <source src={require('../photos/everydaysounds/presentation.mp4')} type="video/mp4"/>
                            </video>
                        </div>

                        <div className="mt-10 border-t border-stone-200" />

                        <div className="mt-10">
                            <h2 className="text-[22px] md:text-[26px] font-normal text-black">Everyday Sounds (V2) — Design Process</h2>

                            <h3 className="mt-10 text-[18px] md:text-[20px] font-medium text-black font-raleway">User Interviews</h3>
                            <p className='mt-2 text-[16px] md:text-[17px] leading-relaxed text-stone-700 font-raleway'>
                                Before revisiting this project, I conducted interviews with three users familiar with popular DAWs (Ableton, Logic, etc.) to gather feedback on the industry landscape and Everyday Sounds v1. I learned that while the design felt intuitive to experienced DAW users, it needed refinement.
                  
                                From here, I became curious about how to support users with little to no experience in DAWs or electronic music production. After interviewing two more colleagues, I discovered that the tool felt confusing to newcomers. To address this, I implemented a more detailed Instructions section, an About page, animation states to signal interactivity, a simplified color scheme, bug fixes, and a streamlined feature set.
                            </p>

                            <h3 className="mt-10 text-[18px] md:text-[20px] font-medium text-black font-raleway">High Fidelity Wireframes</h3>
                            <p className="mt-4 text-center text-[15px] text-stone-500 font-raleway">initial rounds</p>
                            <div className="mt-3 flex flex-col md:flex-row place-content-center gap-4">
                                <img className="w-[95%] md:w-[45%] object-cover" src={require('../photos/everydaysounds/esv2_mock1.png')} alt="first hi-fi wireframe"/>
                                <img className="w-[95%] md:w-[45%] object-cover" src={require('../photos/everydaysounds/esv2_mock2.png')} alt="first hi-fi wireframe"/>
                            </div>
                            <p className="mt-8 text-center text-[15px] text-stone-500 font-raleway">final</p>
                            <img className="mt-3 w-[95%] md:w-[80%] mx-auto h-auto object-cover border border-black" src={require('../photos/everydaysounds/esv2_final.png')} alt="first hi-fi wireframe"/>
                        </div>

                        <div className="mt-10 border-t border-stone-200" />

                        <div className="mt-10">
                            <h2 className="text-[22px] md:text-[26px] font-normal text-black">Style Guide</h2>

                            <h3 className="mt-6 text-[18px] md:text-[20px] font-medium text-black font-raleway">Color</h3>
                            <div className="mt-4 flex flex-row gap-3">
                                <div className="w-[10vw] h-[10vw] md:w-[4vw] md:h-[4vw] bg-fuchsia-400"></div>
                                <div className="w-[10vw] h-[10vw] md:w-[4vw] md:h-[4vw] bg-cyan-400"></div>
                                <div className="w-[10vw] h-[10vw] md:w-[4vw] md:h-[4vw] bg-white border-black border-[1px]"></div>
                                <div className="w-[10vw] h-[10vw] md:w-[4vw] md:h-[4vw] bg-black border-white border-[1px]"></div>
                            </div>

                            <h3 className="mt-10 text-[18px] md:text-[20px] font-medium text-black font-raleway">Typography</h3>
                            <div className='mt-4 flex flex-col md:flex-row gap-6' style={secondaryFontStyle}>
                                <p className='font-limelight text-[21pt] mr-[5vw]'>Limelight</p>
                                <p className='text-[21pt] font-raleway'>Urbanist</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

    )
}

export default EverydaySounds